import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HistoricoConsultasComponent } from './historico-consultas.component';
import { HistiricoConsultasRoutingModule } from './historico-consultas-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatIconModule,
    MatSelectModule,
    NgxMaterialTimepickerModule.setOpts('', ''),
    HistiricoConsultasRoutingModule
  ],
  declarations: [HistoricoConsultasComponent]
})
export class HistoricoConsultasModule {}
